import React, { useState, useEffect } from 'react';
import { NavLink } from "react-router-dom";
import Cookies from 'js-cookie';
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";

import { Avatar } from 'primereact/avatar';

import { Menubar } from 'primereact/menubar';

import '../styles/index.scss';

function getSessionStorageOrDefault(key, defaultValue) {
    const stored =  sessionStorage.getItem(key);
    if (!stored) {
      return defaultValue;
    }
    return JSON.parse(stored);

  }

export default function Header({ setIsAuthenticated, setWorkflow }) {
    const [dropdown, setDropdown] = useState(false);
    const [cookies, setCookie, removeCookie] = useCookies(['auth', 'userid']);
    const navigate = useNavigate();

    const [userDetails, setUserDetails] = useState(             // eslint-disable-line no-unused-vars
        getSessionStorageOrDefault('userDetails', null)
    );

    const [name, setName] = useState();
    useEffect(() => {
        let username = '';
        // Access initial value from session storage
        username = sessionStorage.getItem("usernamevalue") || '[]';
        const first_initial = Array.from(JSON.parse(username))[0].toUpperCase();

        setName(first_initial);
    }, []); //No dependency to trigger in each page load

    const logout = () => {
        Cookies.remove('token');
        Cookies.remove('Useraccesstoken')
        localStorage.removeItem('username');
        removeCookie('auth', { path: '/' });

        sessionStorage.clear();
        setIsAuthenticated(false);
        navigate('/')
    }

    const found_view_data = userDetails.permissions.find(permission => permission.codename === 'view_data') || null;
    const found_view_workflow = userDetails.permissions.find(permission => permission.codename === 'view_workflows') || null;
    const found_view_visualization = userDetails.permissions.find(permission => permission.codename === 'view_visualizations') || null;
    const found_view_usermanagement = userDetails.permissions.find(permission => permission.codename === 'view_usermanagement') || null;

    const items = [];

    // determine current page
    let locEnd = 0;
    for (let i = 1; i <= window.location.pathname.length; i++) {
        if (window.location.pathname[i] === '/' || i === window.location.pathname.length) {
            locEnd = i;
            break;
        }
    }
    
    const loc = window.location.pathname.slice(1, locEnd);

    if (found_view_data) {
        items.push({
            label: 'Data',
            command: () => {navigate('/datasets') },
            style: {
                textDecoration: loc === 'datasets' ? 'underline orange 3px' : ''
            }
        });
    }

    if (found_view_workflow) {
        items.push({
            label: 'Workflows',
            command: () => {navigate('/workflows') },
            style: {
                textDecoration: loc === 'workflows' ? 'underline orange 3px' : ''
            }
        });
    }

    if (found_view_visualization) {
        items.push({
            label: 'Visualizations',
            command: () => {navigate('/visualizations') },
            style: {
                textDecoration: loc === 'visualizations' ? 'underline orange 3px' : ''
            }
        });
    }

    if (found_view_usermanagement) {
        items.push({
            label: 'User Management',
            command: () => {navigate('/usermanagement') },
            style: {
                textDecoration: loc === 'usermanagement' ? 'underline orange 3px' : ''
            }

        });
    }

    items.push({
        label: 'Help',
        icon: 'pi pi-fw pi-question-circle',
        items: [
            {
                label: 'Help Center',
                icon: 'pi pi-plus',
                command: () => { window.open('https://avellino.atlassian.net/servicedesk/customer/portal/19', '_blank') }
            },
            {
                label: 'Contact Support',
                icon: 'pi pi-envelope',
                items: [
                    {
                        label: 'Email - palmona-support@avellino.atlassian.net',
                        icon: 'pi pi-envelope',
                        command: () => { window.open('mailto:palmona-support@avellino.atlassian.net?Subject=Palmona%20P3%20Application', '_blank') },
                        style: {
                            width: '30em'
                        }
                    },
                    {
                        label: 'Call - (650)-396-3741',
                        icon: 'pi pi-phone',
                        command: () => { window.open('tel:1-650-396-3741', '_blank') },
                        style: {
                            width: '30em'
                        }
                    }
                ]
            },
        ]
    });

    items.push({
        label: 'Profile',
        icon: 'pi pi-fw pi-user',
        items: [
            {
                label: 'Edit Profile',
                icon: 'pi pi-fw pi-pencil',
                command: () => {navigate('/userProfile') }
            },
            {
                label: 'Sign Out',
                // icon: 'pi pi-fw pi-box-arrow-right',
                icon: 'pi pi-fw pi-power-off',
                command: () => { logout(); }
            }
        ]
    });

    const start = <NavLink to="/"><img alt="Palmona Dashboard logo" src={require('../assets/images/logo.svg').default} height="40" className="mr-2"></img></NavLink> ;
    // const end = <InputText placeholder="Search" type="text" className="w-full" />;
    const end = (
        <div className="flex align-items-center gap-2">
            {/* <InputText placeholder="Search" type="text" className="w-8rem sm:w-auto" /> */}
            {/* <Avatar image="https://primefaces.org/cdn/primevue/images/avatar/amyelsner.png" shape="circle" /> */}
            <Avatar label={name} size="xlarge" style={{ backgroundColor: '#2196F3', color: '#ffffff' }} />
        </div>
    );

    return (
        <header className="sticky-top bg-dark p-0">
            <div className="header-menu col p-0">
                <Menubar model={items} start={start} end={end}/>
            </div>
        </header>   
    );
}
